import { SortersType } from '@lumapps/lumx-filter-and-sort/types';
import { GLOBAL } from '@lumapps/translations';

import { ARTICLES_SORTING } from './types';

export const ARTICLES_IN_COMMUNITIES_FF = 'articles';

/** Maximum number of article ids the backend accepts per `articles` GET call. */
export const MAX_ARTICLE_IDS_PER_CALL = 30;

export const WIDGET_ARTICLE_LIST_TYPE = 'article-list';

export const SORT_FIELDS: SortersType[] = [
    { id: ARTICLES_SORTING.CREATED_DESC, label: GLOBAL.SORT_NEWEST },
    { id: ARTICLES_SORTING.CREATED_ASC, label: GLOBAL.SORT_OLDEST },
];
